import { faPenCircle } from "@fortawesome/pro-regular-svg-icons/faPenCircle";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons/faTrashAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { DeletePublicationFactory } from "views/knowledge/components/card/behaviors/common/DeletePublicationFactory";
import { EditPublicationFactory } from "views/knowledge/components/card/behaviors/common/EditPublicationFactory";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { useCardManagerStyles } from "views/knowledge/components/card/CardManagerStyles";

///
export const IconActions = () => {
    const { pub: { publicationId, publicationType, masterPublication, title, isDraft, interaction: { allowDelete, allowEdit } }, onFeedItemChanged, onReload } = useCardContext();
    const [dialog, setDialog] = useState<React.ReactNode | null>(null);
    const { classes } = useCardManagerStyles();
    const { t } = useTranslation("shared");

    const doEdit = useCallback(() => {
        setDialog(<EditPublicationFactory
            publicationId={publicationId}
            publicationType={publicationType}
            masterPublicationId={masterPublication?.publicationId}
            masterTitle={title}
            onClose={(success) => { setDialog(null); if (success) onReload(); }}
        />);
    }, []);

    const doDelete = useCallback(() => {
        setDialog(<DeletePublicationFactory
            publicationId={publicationId}
            title={title}
            isDraft={isDraft}
            publicationType={publicationType}
            isThread={masterPublication != null}
            onClose={
                (deleted) => {
                    if (deleted) onFeedItemChanged({ deletedOn: new Date() });
                    setDialog(null);
                }
            }
        />);
    }, []);

    if (!allowEdit && !allowDelete)
        return null;

    return (
        <>
            {dialog}

            <div style={{ height: 24 }} className={classes.cardMouseOut}>
                {
                    allowEdit &&
                    <IconButton color="default" size="small" title={t("Actions.Edit")} onClick={doEdit} >
                        <FontAwesomeIcon icon={faPenCircle} fixedWidth />
                    </IconButton>
                }

                {
                    allowDelete &&
                    <IconButton color="error" size="small" title={t("Actions.Delete")} onClick={doDelete} >
                        <FontAwesomeIcon icon={faTrashAlt} fixedWidth />
                    </IconButton>
                }
            </div>
        </>
    );
};
